import angular from 'angular';

module.exports = angular.module('common.services.login-modal', [
  require('angular-ui-bootstrap'),
])
.factory('loginSignupModal', function($uibModal, $rootScope, $timeout) {
  return {
    show: function(signupType, tab) {
      if ($rootScope.session.human) {
      // the $location.search update in market.js was failing inconsistently in this logged-in
      // shortcut case. Returning a 0s timeout promise fixes it (maybe giving angular a chance
      // to catch up between updating the human and triggering the location change?)
      // Not really sure.
        return $timeout();
      }

      var instance = $uibModal.open({
        template: require('./login-signup-modal.jade')(),
        controller: 'login_modal',
        controllerAs: 'login_modal',
        resolve: {
          tab: () => tab,
          signupType: () => signupType,
        }
      });

      return instance.result;
    },
  };
}).controller('login_modal', class {
  constructor($rootScope, $window, Human, Session, Analytics, $uibModalInstance, $timeout, tab,
              signupType) {
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.Human = Human;
    this.Session = Session;
    this.errors = {};
    this.loginError = false;
    this.session = this.$rootScope.session;
    this.signupType = signupType;
    this.Analytics = Analytics;
    this.$uibModalInstance = $uibModalInstance;
    this.$timeout = $timeout;

    this.password = '';
    this.pending = false;

    this.$rootScope.inloginSignupModal = true;

    this.showTab(tab || 'signup');
  }

  showTab(tab_name) {
    this.tab = tab_name;
    this.$timeout(() => {
      // focus first form input
      document.querySelector('#' + tab_name + '-modal-form input').select();
    });
  }

  cancel() {
    this.$rootScope.inloginSignupModal = false;
    this.$uibModalInstance.dismiss();
  }

  signup() {
    this.pending = true;
    let newHuman = new this.Human({
      signup_type: this.signupType,
      full_name: this.fullName,
      email: this.email,
      primary_phone: this.phoneNumber,
      password: this.password,
    });
    newHuman.$register().then(() => {
      this.Analytics.event('signup', 'submit', 'signup-success');
      this.pending = false;
      // Fetch the latest login information
      return this.session.$me();
    }).then(() => {
      this.$rootScope.inloginSignupModal = false;
      this.$uibModalInstance.close();
    }).catch((e) => {
      this.Analytics.event('signup', 'submit', 'signup-error');
      this.pending = false;
      this.errors = e.data.errors;
    });
  }

  login() {
    this.pending = true;
    let human = new this.Human({
      email: this.email,
      password: this.password,
    });
    let newSession = new this.Session({
      human: human,
    });
    newSession.$login().then(() => {
      this.pending = false;
      // Fetch the latest login information
      return this.session.$me();
    }).then(() => {
      this.$rootScope.inloginSignupModal = false;
      this.$uibModalInstance.close();
    }).catch(() => {
      this.pending = false;
      this.loginError = true;
    });
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/services/login-signup-modal.js
 **/